(function defineCustomEventHandlers($, window) {
    "use strict";

    function initCustomEventHandlers() {
        window.THEME.$document.on("checkoutFormInputKeyup", storeCheckoutFormInput);
        window.THEME.$document.on("validateFormInputOnKeyup", validateFormInputOnKeyup);
        window.THEME.$document.on("validateFormInputOnBlur", validateFormInputOnBlur);
        window.THEME.$document.on("validateFormInputBeforeContinue", validateFormInputBeforeContinue);
        window.THEME.$document.on("checkoutFormRadioInputChange", storeCheckoutFormInput);
        window.THEME.$document.on("formValidationDone", afterFormValidation);
        window.THEME.$document.on("clickOnReplacedRadioButton", handleClickOnReplacedRadioButton);
        window.THEME.$document.on("oneTimeTogglerClick", handleOneTimeTogglerClick);
        window.THEME.$document.on("paymentMethodClicked", handlePaymentMethodClick);
        window.THEME.$document.on("paymentOptionContinueClick", handlePaymentOptionContinueClick);
        window.THEME.$document.on("creditCardNumberInputFirstField", handleCreditCardNumberInputFirstField);
        window.THEME.$document.on("creditCardNumberInputAnyField", handleCreditCardNumberInputAnyField);
        window.THEME.$document.on("setValidationData", handleSetValidationData);
        window.THEME.$document.on("checkoutFormSelectChange", storeCheckoutFormInput);
        window.THEME.$document.on("checkoutAcceptTermsAndConditions", handleAcceptedTermsAndConditions);
    }

    ////////////////////////////////////
    //       Global Handlers          //
    ////////////////////////////////////

    /**
     * Publish events to subscribers
     */
    window.THEME.publish = function (evName, data) {
        window.THEME.$document.trigger(evName, data);
    };

    /**
     * Subscribe to global event
     */
    window.THEME.subscribe = function (evName, callback) {
        window.THEME.$document.on(evName, callback);
    };


    ///////////
    // SHAME //
    ///////////
    var storageType = 'local';

    function storeCheckoutFormInput(event, $inputField) {
        //var fieldValue    = $inputField.val();
        var fieldId = $inputField.attr("id");
        var fieldType = $inputField.attr("type");
        var radioButtonId = false;
        var allowStorage = ($inputField.data("no-storage") !== 1);
        var useSession = window.THEME.Utils.isSessionStorageOnly(fieldId);

        if (allowStorage === true && fieldType !== "hidden") {
            if ($inputField.attr("type") === "radio" || $inputField.attr("type") === "select-one") {
                radioButtonId = fieldId;
            }

            window.THEME.Utils.storeFormFieldValue($inputField, useSession ? "session" : storageType, radioButtonId);
        }
    }

    function handleAcceptedTermsAndConditions() {
        var submitBtn = $(".checkout-submit-btn");
        var paypalBlock = $(".paypalDelticore-button");

        function updateTermsState() {
            var checkbox = $("#acceptedTermsAndConditions");
            var accepted = checkbox.length && checkbox.prop("checked");

            submitBtn.prop("disabled", !accepted);
            paypalBlock.toggleClass("disabled-paypal", !accepted);
        }

        $(document)
            .off("change.acceptedTermsAndConditions", "#acceptedTermsAndConditions")
            .on("change.acceptedTermsAndConditions", "#acceptedTermsAndConditions", updateTermsState);

        updateTermsState();
    }

    function afterFormValidation(event, $element) {
        var $form = $element.closest('form');
        var formId = $form.attr('id');

        switch (formId) {
            case 'checkoutForm':
                var $checkoutStep = $element.closest('.checkoutStep');

                if ($checkoutStep.is(':visible')) {
                    window.Checkout.afterValidationOfCheckoutForm($checkoutStep);
                }

                break;
            default:
                /* do nothing */
                break;
        }
    }

    function validateFormInputOnKeyup(event, $element) {
        window.THEME.FormValidation.validateFormField($element, 'keyup');
    }

    function validateFormInputOnBlur(event, $element) {
        window.THEME.FormValidation.validateFormField($element, 'focusout');
        window.THEME.$document.trigger('formValidationDone', [$element]);
    }

    function validateFormInputBeforeContinue(event, $element) {
        window.THEME.FormValidation.validateFormField($element, 'validate-before-continue');
        window.THEME.$document.trigger('formValidationDone', [$element]);
    }

    function handleClickOnReplacedRadioButton(event, $replacedRadioButton) {
        if ($replacedRadioButton.prop('disabled')) {
            return false;
        }

        $replacedRadioButton.prop('checked', true);
        window.THEME.Utils.updateReplacedRadioButtonStates($replacedRadioButton);
        $replacedRadioButton.trigger('keyup');

        return false;
    }

    function handleOneTimeTogglerClick(event, $togglerLink) {
        var $togglerElement;
        var $toggleElements;

        if (typeof $togglerLink === 'object' && $togglerLink.get(0).nodeName.toLowerCase() === 'a') {
            $togglerElement = $togglerLink.closest('.togglerContainer');
            $toggleElements = $togglerElement.siblings('.toggleTarget');

            $togglerLink.on("click", window.THEME.Utils.oneTimeToggle($togglerElement, $toggleElements));
        }
    }

    function handlePaymentMethodClick(event, $paymentMethodRadioButton) {
        var $subformContainer = $paymentMethodRadioButton.siblings('.paymentMethodSubformContainer');

        window.Checkout.paymentMethods.loadPaymentMethodSubform($subformContainer);
    }

    function handlePaymentOptionContinueClick(event, $button, paymentMethod) {
        var $currentSubFormContainer;

        if (!window.Checkout.steps.vars.locked && typeof $button === 'object' && typeof paymentMethod === 'string') {
            if (!window.THEME.Utils.isLocked($button)) {
                $currentSubFormContainer = window.Checkout.steps.getCurrentSubFormContainer();

                if (window.Checkout.currentFormValidates($currentSubFormContainer)) {
                    if (window.THEME.FormValidation.validatePaymentMethodSubform(paymentMethod) === false) {
                        return;
                    }

                    window.THEME.Utils.lockElement($button);
                    window.Checkout.paymentMethods.continueWith(paymentMethod);
                }
            }
        }
    }

    function handleCreditCardNumberInputFirstField(event, $firstInputField, valueToSplit) {
        var $remainingInputFields = $firstInputField.siblings('input.ccNumber:lt(4)');
        var remainingInputFieldsEmpty = true;
        var splittedValues;
        var i;
        var $currentField;

        $remainingInputFields.each(function checkIfEachInputFieldEmpty(index, inputField) {
            if (inputField.value !== '') {
                remainingInputFieldsEmpty = false;
                return false;
            }
        });

        if (remainingInputFieldsEmpty) {
            splittedValues = valueToSplit.match(/\d{1,4}/g);
            $firstInputField.val(splittedValues[0]);
            $firstInputField.trigger('keyup');
            $firstInputField.trigger('focusout');

            for (i = 1; i <= $remainingInputFields.length; i++) {
                $currentField = $remainingInputFields.eq(i - 1);
                $currentField.val(splittedValues[i]);
                $currentField.trigger('keyup');
                $currentField.trigger('focusout');
            }
        }
    }

    function handleCreditCardNumberInputAnyField(event, $ccNumberInputFields) {
        var completeCcNumber = window.Checkout.combineFieldValues($ccNumberInputFields);

        window.Checkout.handleCreditCardType(completeCcNumber);
    }

    function handleSetValidationData(event, value) {
        var $element = $(event.target);
        var $formRow;

        if ($element) {
            $element.attr('data-validation-state', value);

            if (!$element.hasClass('j-validation-group')) {
                $formRow = window.THEME.FormValidation.getFormRowOfFormElement($element);
                window.THEME.FormValidation.updateFormRowClasses($formRow);
            }
        }
    }

    window.THEME.CustomEventHandlers = {
        init: initCustomEventHandlers,
        afterFormValidation: afterFormValidation,
        handleClickOnReplacedRadioButton: handleClickOnReplacedRadioButton,
        handleCreditCardNumberInputAnyField: handleCreditCardNumberInputAnyField,
        handleCreditCardNumberInputFirstField: handleCreditCardNumberInputFirstField,
        handleOneTimeTogglerClick: handleOneTimeTogglerClick,
        handlePaymentMethodClick: handlePaymentMethodClick,
        handlePaymentOptionContinueClick: handlePaymentOptionContinueClick,
        handleSetValidationData: handleSetValidationData,
        storeCheckoutFormInput: storeCheckoutFormInput,
        validateFormInputBeforeContinue: validateFormInputBeforeContinue,
        validateFormInputOnBlur: validateFormInputOnBlur,
        validateFormInputOnKeyup: validateFormInputOnKeyup
    };

    // Spread the pasted CC number over the four separate input fields:
    $(document).ready(function defineCustomEventHandlersDocumentReady() {
        window.THEME.CustomEventHandlers.init();
    });
}(window.jQuery, window));
